import Image, { StaticImageData } from "next/legacy/image";
import * as S from "./MktLandingPageConcernCard.style";

export default function MktLandingPageConcernCard({
  icon,
  desc,
  marketerType,
  variation,
}: {
  icon: StaticImageData;
  desc: JSX.Element;
  marketerType: string;
  variation?: string;
}) {
  return (
    <S.Card variation={variation}>
      <Image src={icon} width={28} height={28} alt="icon" />
      <S.Desc>{desc}</S.Desc>
      <S.MarketerType>{marketerType}</S.MarketerType>
    </S.Card>
  );
}
